export const VERSION = "1.0.0-beta";

export default VERSION;